import {Product} from './product.model';
import {Partner} from './partner.model';
import {DictionaryItem} from './dictionary.model';
import {GenericEntity} from './generic-entity.model';
import {CoAcquisitionOperation} from '../enums/operations.enum';

export class CoAcquisition extends GenericEntity {
    product: Product;
    sellingPartners: Partner[];
    partner: Partner;
    policyPayment: DictionaryItem = new DictionaryItem({code: 'SINGLE'});
    valueType: DictionaryItem = new DictionaryItem({code: 'NETTO'});
    rate: number;
    punu: string;
    availableOperations?: CoAcquisitionOperation[];

    constructor(props = {}) {
        super(props);
        Object.assign(this, props);
    }

    isOperationEnabled(operation: string) {
        return this.availableOperations?.includes(operation as CoAcquisitionOperation);
    }
}
